import { NgModule } from "@angular/core";
import { PaginationComponent } from './pagination.component';
import { CommonModule } from '@angular/common';
import { LinkModule } from 'src/app/shared/link/link.module';

@NgModule({
    imports:[
        LinkModule,
        CommonModule
    ],
    declarations: [
        PaginationComponent
    ],
    exports:[
        PaginationComponent
    ]
})

export class PaginationModule{

}